export default __webpack_public_path__ + "static/media/screen4.411fdfa9.png";